module.exports = __webpack_public_path__ + "img/envelopamento3.100d6809.jpeg";